import { useTranslation } from "react-i18next";
import { getLanguage, setLanguage } from "@/i18n";
import type { Language } from "@/i18n/resolve-language";

interface UseLanguageResult {
  language: Language;
  setLanguage: (lng: Language) => void;
}

/** Active UI language plus its setter. Re-renders when the language changes. */
export function useLanguage(): UseLanguageResult {
  // Subscribing to react-i18next is what re-renders the caller on a switch;
  // the returned instance is otherwise unused.
  useTranslation();
  return { language: getLanguage(), setLanguage };
}
